import { getUserProfile } from '../../services/getUserProfile';
import { setUserProfilePending, setUserProfileSucceed, setUserProfileFailed } from '../../slices/userProfileSlice';
import { TThunkAction } from '../../types/redux/thunk';

export const fetchUserProfileThunk =
  (chatId: string): TThunkAction<Promise<void>> =>
  async (dispatch, _, { httpApi, logger }) => {
    dispatch(setUserProfilePending({ chatId }));

    const profile = await getUserProfile({ httpApi, logger, chatId });

    if (profile) {
      dispatch(setUserProfileSucceed({ chatId, clientInfo: profile.clientInfo }));

      return;
    }

    dispatch(setUserProfileFailed({ chatId }));
  };
